<template>
    <svg
        v-bind="svgAttributes"
        v-html="svgContent"
    >
    </svg>
</template>

<script>
import { computed } from 'vue';

/**
 * Replaces class labels in SVG string with unique identifiers to prevent conflicts
 * @param {string} svgString - The SVG string to process.
 * @returns {string} The modified SVG string with unique class identifiers.
 */
function generateUniqueClasses(svgString) {
    if (!svgString || typeof document === 'undefined') return '';

    const uniqueString = Math.random().toString(36) .substring(2) + Date.now().toString(36);

    // Replace class rules in style tag
    svgString = svgString.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, function(match, styleContent) {
        return '<style>' + styleContent.replace(/\.(\w+)[^{\n]*{/gi, function(styleMatch, className) {
            return '.' + className + uniqueString + ' {';
        }) + '</style>';
    });

    // Replace class attributes in other tags
    svgString = svgString.replace(/<([^>]*)\sclass\s*=\s*['"]([^'"]*)['"]/gi, function(match, tag, classes) {
        var uniqueClasses = classes.split(' ').map(function(className) {
            return className + uniqueString;
        }).join(' ');
        return '<' + tag + ' class="' + uniqueClasses + '"';
    });

    return svgString;
}

export default {
    name: 'SvgVue',

    props: {
        icon: String
    },

    setup(props) {
        const iconName = computed(() => props.icon.replace(new RegExp('.'.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'), 'g'), '/'));

        const modules = import.meta.glob('../../../../svg/front/**/*.svg', {
            as: 'raw',
            eager: true,
        });

        const svgString = computed(() => modules['../../../../svg/front/' + iconName.value + '.svg'] || '');

        const svgAttributes = computed(() => {
            if (!svgString.value || typeof document === 'undefined') return {};

            let wrapper = document.createElement('div');
            wrapper.innerHTML = svgString.value;

            let attributesList = wrapper.firstElementChild?.attributes || [];
            let attributes = {};

            Object.keys(attributesList).map(i => attributes[attributesList[i].name] = attributesList[i].value);

            return attributes;
        });

        const svgContent = computed(() => {
            if(!svgString.value) return null;

            return generateUniqueClasses(svgString.value).replace(/^<svg[^>]*>|<\/svg>$/g, '');
        });

        return {svgAttributes, svgContent};
    }
}
</script>
